module.exports = __webpack_public_path__ + "static/images/video.62044a67f16e97c42d2580134b361d89.svg";